<template>
  <div>
    <div
      v-if="strapiData"
      class="page--customer-service"
    >
      <!-- Disabled for home -->
      <AppBreadcrumbs
        v-if="$route.path !== '/'"
        class="container"
      />

      <StrapiSlices
        v-if="strapiData?.customerServicePage?.Slices?.length"
        :slices="strapiData.customerServicePage.Slices"
      />
    </div>

    <DevOnly v-else-if="strapiError">
      <pre>strapiError: {{ strapiError }}</pre>
    </DevOnly>

    <slot />
  </div>
</template>

<script lang="ts" setup>
const meta = inject('meta', ref())
const { strapiData, strapiError, getStrapiData } = useStrapiCms(meta?.value?.strapi_id, undefined, 'customerServicePage', undefined)
const { t } = useI18n({ useScope: 'global' })

await getStrapiData()

const pageTitle = computed(
  () => strapiData.value?.customerServicePage?.PageTitle || '',
)

const metaTitle = computed(
  () => strapiData.value?.customerServicePage?.MetaTitle || pageTitle.value,
)

const metaDescription = computed(
  () => strapiData.value?.customerServicePage?.MetaDescription || pageTitle.value + ' | ' + t('nuxtSiteConfig.description'),
)

const { setBreadcrumbs } = useBreadcrumbs()
setBreadcrumbs({
  label: metaTitle.value,
  parents: meta.value.parents,
})

const { pageView } = useDataLayer()
pageView('customer-service', metaTitle.value)

useHead({
  title: metaTitle,
  meta: [
    { hid: 'description', name: 'description', content: metaDescription },
    { hid: 'robots', name: 'robots', content: strapiData.value?.customerServicePage?.MetaData?.MetaRobots?.replace('_', ', ') },
  ],
  script: [
    { type: 'application/ld+json', hid: 'RichSnippets', innerHTML: strapiData.value?.MetaData?.RichSnippets || '' },
  ],
})

const route = useRoute()
const { canonical } = useSeo()
canonical(computed(() => route.path))
</script>

<style src="~layers/app/pages/~customer-service.css" />
